import antMessage from 'antd/lib/message'
import { ApiError } from '../util/errors/ApiError'
import { ValidationError } from '../util/errors/ValidationError'
import { DateError } from '../util/errors/DateError'

type MessageFn = (message: string) => void

type Return = {
    success: MessageFn
    danger: MessageFn
    error: (error: Error) => void
}

const DEFAULT_DURATION_MS = 3000

export const useMessage = (durationMS = DEFAULT_DURATION_MS): Return => {
    const durationS = durationMS / 1000
    return {
        success: (message: string) => {
            antMessage.success(message, durationS)
        },
        danger: (message: string) => {
            antMessage.error(message, durationS)
        },
        error: (error: Error | string): void => {
            const GENERIC_ERROR = 'Something went wrong, please contact Navtrac support.'
            if (error instanceof ApiError) {
                let message = ''

                switch (error.type) {
                    case 'BadRequest':
                        message = 'Invalid request, please try again.'
                        break
                    case 'Forbidden':
                    case 'Unauthorized':
                        message = 'You are not authorized to perform this action.'
                        break
                    case 'NotFound':
                        message = 'The requested resource was not found'
                        break
                    default:
                        message = GENERIC_ERROR
                }
                antMessage.error(message)
                return
            }

            if (error instanceof ValidationError || error instanceof DateError) {
                antMessage.error(GENERIC_ERROR)
                return
            }

            if (error instanceof Error) {
                antMessage.error(error.message)
                return
            }

            antMessage.error(GENERIC_ERROR)
        },
    }
}
